import { useMap } from 'ms-map-gl'
import { useEffect } from 'react'

interface ClusterZoomPluginProps {
  source: string
  layer: string
}

function ClusterZoomPlugin(props: ClusterZoomPluginProps) {
  const { source, layer } = props

  const mapGl = useMap()

  useEffect(() => {
    const map = mapGl.current

    if (!map) return

    const handleClick = async (event) => {
      const features = map.queryRenderedFeatures(event.point, {
        layers: [layer]
      })

      const feature = features[0]
      if (!feature) return

      const clusterId = feature.properties?.cluster_id as string | undefined
      if (!clusterId) return

      const zoom = await (map.getSource(source) as any).getClusterExpansionZoom(
        clusterId
      )

      map.easeTo({
        center: (feature.geometry as any).coordinates,
        zoom
      })
    }

    map.on('click', layer, handleClick)
    return () => {
      map.off('click', layer, handleClick)
    }
  }, [])

  return <></>
}

export { ClusterZoomPlugin }
